<template>
  <template v-if="$q.screen.gt.sm">
    <q-tr :props="slotProps">
      <q-th
        v-for="col in columns"
        :key="col.name"
        :props="slotProps"
        class="header"
      >
        {{ col.label }}
      </q-th>
    </q-tr>
    <tr
      v-if="showFilters"
      class="filter-header"
    >
      <th
        v-for="col in columns"
        :key="col.name"
      >
        <ColumnFilter
          :show-label="false"
          :col="col"
          :model-value="colFilters"
        />
      </th>
    </tr>
  </template>
  <template v-else-if="showFilters">
    <template
      v-for="col in columns"
      :key="col.name"
    >
      <ColumnFilter
        :show-label="true"
        :col="col"
        :model-value="colFilters"
      />
    </template>
  </template>
</template>

<script setup>
import { computed } from 'vue'

import ColumnFilter from './ColumnFilter.vue'

const props = defineProps({
  slotProps: {
    type: Object,
    required: true,
  },
  showFilters: {
    type: Boolean,
    default: false,
  },
})

const colFilters = defineModel({
  type: Object,
  required: true,
})

const columns = computed(() => props.slotProps.cols.filter((col) => col.isMain))
</script>

<style scoped lang="scss"></style>
